import { css } from 'glamor';

export default css({
  padding: '12px 16px',
  lineHeight: 1.35,
});
